import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QIResultStatus, TaskFileDetail, TaskMessage, TaskQueueDetail } from 'common/types/taskQueue';
import { RootState } from './index';
import { AppThunk } from '.';
import service from '@/service';
import { setTaskQueue } from './taskQueue';
import { parseFileToStore } from './addVersion';

interface TaskQueueInitialStateProp {
  queue: TaskQueueDetail[];
}
const initialState: TaskQueueInitialStateProp = {
  queue: [],
};
const uploadingTaskQueue = createSlice({
  name: 'uploadingTaskQueue',
  initialState,
  reducers: {
    setUploadingQueue: (state, { payload }: PayloadAction<TaskQueueDetail[]>) => {
      state.queue = payload;
    },
  },
});
export const { setUploadingQueue } = uploadingTaskQueue.actions;
export const selectUploadingTaskQueue = (state: RootState) => state.uploadingTaskQueue.queue;

// 开始上传版本文件
export const addUploadingTask =
  (newTaskQueue: TaskQueueDetail): AppThunk =>
  async (dispatch, getState) => {
    const uploadingQueue = getState()?.uploadingTaskQueue.queue;

    // 判断newTaskQueue是否已经在上传队列中,如果在则不添加
    const isExist = uploadingQueue?.findIndex(item => item.uuid === newTaskQueue.uuid) !== -1;
    if (isExist) {
      return;
    }
    const newUploadingQueue = [...(uploadingQueue ?? []), newTaskQueue];
    dispatch(setUploadingQueue(newUploadingQueue));
  };

// 更新版本上传进度
export const updateUploading =
  (newTaskMessage: TaskMessage, fileList: TaskFileDetail[]): AppThunk =>
  async (dispatch, getState) => {
    const allUploadingQueues = getState()?.uploadingTaskQueue.queue ?? [];
    const { taskId, uuid, fosFileId, fileId, taskProgress, fileProgress, taskStatus, fileStatus } = newTaskMessage;
    let newUploadingQueue: TaskQueueDetail[] = [];
    newUploadingQueue = allUploadingQueues.map(task => {
      if (task.uuid === uuid) {
        const newFileList = fileList.map(file => parseFileToStore(file));

        return {
          ...task,
          ...newTaskMessage,
          fileList: newFileList,
        };
      } else {
        return task;
      }
    });
    dispatch(setUploadingQueue(newUploadingQueue));
  };

// 版本文件上传结束
export const onUploadingTaskDone =
  (uuid: string): AppThunk =>
  async (dispatch, getState) => {
    const taskQueue = getState()?.taskQueue.taskQueue;
    //移除正在上传的任务
    const allUploadingQueue = getState()?.uploadingTaskQueue.queue;
    const res = await service.taskQueue.getListBackground();

    const { data: newList } = res || {};

    // 把当前uuid的任务，从allUploadingQueue移出，放到taskQueue中，修改taskQueue
    const newUploadingQueue = allUploadingQueue?.filter(task => task.uuid !== uuid);
    const newTasks = newList.map(task => {
      const uploadingTask = newUploadingQueue?.find(item => item.uuid === task.uuid);
      return uploadingTask ? { ...task, fileList: uploadingTask.fileList } : task;
    });

    dispatch(setTaskQueue(newTasks));
    dispatch(setUploadingQueue(newUploadingQueue));
  };

export default uploadingTaskQueue.reducer;
